__turbopack_context__.v({
  "body": "modal-module__AJVEzG__body",
  "closeButton": "modal-module__AJVEzG__closeButton",
  "content": "modal-module__AJVEzG__content",
  "footer": "modal-module__AJVEzG__footer",
  "header": "modal-module__AJVEzG__header",
  "headerWithIcon": "modal-module__AJVEzG__headerWithIcon",
  "icon": "modal-module__AJVEzG__icon",
  "iconTitle": "modal-module__AJVEzG__iconTitle",
  "multiStepTitle": "modal-module__AJVEzG__multiStepTitle",
  "negativeButton": "modal-module__AJVEzG__negativeButton",
  "root": "modal-module__AJVEzG__root",
  "title": "modal-module__AJVEzG__title",
});
